/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { injectIntl } from 'react-intl';
import { toAbsoluteUrl } from '../../../_metronic/_helpers';
import { CardHeader } from '../../components/CardHeader';
import { Loading } from '../../components/Loading';
import {
  Body,
  Cell,
  Head,
  HighlightableRow,
  Table,
} from '../../components/Table';
import { usePermissions } from '../../contexts/PermissionsContext';
import { useSelector } from 'react-redux';
import EditProjectsMenu from './EditProjectsMenu';
import { Dialog, Divider } from '@material-ui/core';
import { AddButton } from '../../components/AddButton';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';

function ProjectsPage({ intl }) {
  const user = useSelector(({ auth }) => auth.user);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setOpen] = useState({ edit: false, delete: false });
  const [selectedProject, setSelectedProject] = useState(null);
  const [projects, setProjects] = useState([]);
  const { hasPermission } = usePermissions();
  const { setPaths } = useBreadcrumb();

  useEffect(() => {
    getProjects();
    setPaths([
      { title: intl.formatMessage({ id: 'PROJECTS' }), pathname: `/projects` },
    ]);
  }, []);

  async function getProjects() {
    try {
      setIsLoading(true);
      const { data } = await axios.get('/projects');
      if (data) setProjects(data);
    } finally {
      setIsLoading(false);
    }
  }

  function selectProject(project) {
    if (hasPermission('projects*', 'U')) {
      setOpen({ edit: true, delete: false });
      setSelectedProject(project);
    }
  }

  function onCloseEdit() {
    setOpen({ edit: false, delete: false });
    setSelectedProject(null);
  }

  async function deleteProject() {
    closeModal();
    try {
      setIsLoading(true);
      await axios.delete(`/projects/${selectedProject.id}`);
      await getProjects();
    } finally {
      setIsLoading(false);
    }
  }

  function setDeleteOpen(proj, e) {
    stopPropagation(e);
    setSelectedProject(proj);
    setOpen({ edit: false, delete: true });
  }

  function closeModal() {
    setOpen({ edit: false, delete: false });
    setSelectedProject(null);
  }

  function stopPropagation(e) {
    e.stopPropagation();
  }

  return (
    <div className="card flex-row-fluid h-100">
      <CardHeader
        title={intl.formatMessage({ id: 'PROJECTS' })}
        subtitle={intl.formatMessage(
          { id: 'PROJECTS.SUBTITLE' },
          { name: user.entityName }
        )}
        btn={
          hasPermission('projects*', 'C') && (
            <AddButton onClick={() => setOpen({ delete: false, edit: true })} />
          )
        }
      />
      <div className="card-body" id="projects-container">
        <Loading isLoading={isLoading} />
        <Table>
          <Head>
            <Cell width="45%"> {intl.formatMessage({ id: 'NAME' })} </Cell>
            <Cell width="45%">
              {' '}
              {intl.formatMessage({ id: 'DESCRIPTION' })}{' '}
            </Cell>
            <Cell align="center">
              {intl.formatMessage({ id: 'MENU.ACTIONS' })}
            </Cell>
          </Head>
          <Body>
            {projects.map(proj => (
              <HighlightableRow
                key={proj.id}
                onClick={() => selectProject(proj)}
              >
                <Cell width="45%"> {proj.name} </Cell>
                <Cell width="45%"> {proj.description} </Cell>
                <Cell align="center">
                  <div className="d-flex align-items-center justify-content-center">
                    {hasPermission('projects*', 'D') && (
                      <span
                        className="svg-icon w-25px h-25px d-flex align-items-center justify-content-center btn"
                        style={{ padding: 5 }}
                        onClick={e => setDeleteOpen(proj, e)}
                      >
                        <img
                          src={toAbsoluteUrl('/media/svg/senseworks/bin-1.svg')}
                          alt="remove"
                          width={16}
                          height={16}
                        />
                      </span>
                    )}
                  </div>
                </Cell>
              </HighlightableRow>
            ))}
          </Body>
        </Table>
      </div>
      <EditProjectsMenu
        intl={intl}
        project={selectedProject}
        hasPermission={hasPermission}
        onClose={onCloseEdit}
        open={isOpen.edit}
        entityId={user.entityId}
        getProjects={getProjects}
      />
      {hasPermission('projects*', 'D') && selectedProject && (
        <Dialog onClose={closeModal} open={isOpen.delete}>
          <div style={{ minWidth: '500px' }}>
            <div
              className="col-12 px-4 card-header"
              style={{ fontWeight: 800 }}
            >
              <span>
                {intl.formatMessage({ id: 'ACTIONS.REMOVE.PROJECT.TITLE' })}
              </span>
            </div>
            <div
              className="col-12 py-2 px-4 card-body"
              style={{ minHeight: 80 }}
            >
              <span className="d-block">
                {intl.formatMessage({ id: 'ACTIONS.REMOVE.PROJECT.BODY' })}
              </span>
              <span>
                {intl.formatMessage({
                  id: 'ACTIONS.REMOVE.PROJECT.BODY.ALERT',
                })}
              </span>
            </div>
            <Divider />
            <div
              className="col-12 px-4 d-flex justify-content-end my-2"
              style={{ padding: '0px !important' }}
            >
              <button
                onClick={deleteProject}
                type="button"
                className="btn btn-bordered danger-bg d-flex align-items-center"
                style={{ color: '#FFFFFF', height: 26 }}
              >
                {intl.formatMessage({ id: 'DELETE' })}
              </button>
              <button
                onClick={closeModal}
                type="button"
                className="ml-3 btn btn-bordered d-flex align-items-center"
                style={{ color: '#58595B', height: 26 }}
              >
                {intl.formatMessage({ id: 'CANCEL' })}
              </button>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
}

export default injectIntl(ProjectsPage);
